import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMinusLarge"><Path fillRule="evenodd" clipRule="evenodd" d="M3 11H21V13H3V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinusLarge;
